module.exports = __webpack_public_path__ + "static/beach_scene_02-e6fe0180fe3beff9b9928b5aeac035af.png";